module.exports = __webpack_public_path__ + "static/media/kcc.eaf89b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kcc.png
// module id = 334
// module chunks = 0